import { ComponentRef, Injectable, Provider } from '@angular/core';
import { AddressDto } from 'shared/services/INTEGRA_Shop_Client';
import { IAddressAddDialogService, IAddressAddDialogServiceToken } from './address-add-dialog-service.abstract';
import { DialogBaseService } from '../../dialog.service';
import { AddressAddDialogComponent } from 'shared/components/shared/address/add-dialog/address-add-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class AddressAddDialogService implements IAddressAddDialogService {

  addressAddDialogShow(
    modalTitle: string,
    addressTemplate: AddressDto | undefined,
    callbackSubmit: (result: AddressDto) => void,
    callbackCancel: () => void,
    submitButtonLabel?: string,
    cancelButtonLabel?: string,
  ) {
    DialogBaseService.dialogGenericShow(
      AddressAddDialogComponent,
      (component: ComponentRef<AddressAddDialogComponent>) => {
        component.instance.modalTitle = modalTitle;
        component.instance.addressTemplate = addressTemplate;
        if (submitButtonLabel) {
          component.instance.submitButtonLabel = submitButtonLabel;
        }
        if (cancelButtonLabel) {
          component.instance.cancelButtonLabel = cancelButtonLabel;
        }

        component.instance.modalSubmit.subscribe(
          (result: AddressDto) => {
            callbackSubmit(result);
            DialogBaseService.dynamicComponentRemove(component);
          }
        );
        component.instance.modalCancel.subscribe(
          () => {
            callbackCancel();
            DialogBaseService.dynamicComponentRemove(component);
          }
        );
      }
    );
  }

}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const AddressAddDialogServiceProvider: Provider[] = [
  { provide: IAddressAddDialogServiceToken, useExisting: AddressAddDialogService }
];
